import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function TemperatureIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="12"
        height="17"
        viewBox="0.5 0 11 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 1H0V3H4V1Z" />
        <path d="M4 5H0V7H4V5Z" />
        <path d="M10 8.555V2C10 1.46957 9.78929 0.960859 9.41421 0.585786C9.03914 0.210714 8.53043 0 8 0C7.46957 0 6.96086 0.210714 6.58579 0.585786C6.21071 0.960859 6 1.46957 6 2V8.555C5.23743 8.99527 4.64145 9.67486 4.30448 10.4884C3.96751 11.3019 3.9084 12.2038 4.1363 13.0544C4.3642 13.9049 4.86638 14.6565 5.56495 15.1925C6.26353 15.7286 7.11946 16.0191 8 16.0191C8.88054 16.0191 9.73647 15.7286 10.435 15.1925C11.1336 14.6565 11.6358 13.9049 11.8637 13.0544C12.0916 12.2038 12.0325 11.3019 11.6955 10.4884C11.3586 9.67486 10.7626 8.99527 10 8.555Z" />
      </svg>
    </Icon>
  );
}
